var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"tm-diag-point",style:(_vm.styleObj)},[_c('i',{staticClass:"v"}),_vm._v(" "),_c('i',{staticClass:"h"})])}
var staticRenderFns = []

export { render, staticRenderFns }